export const CREATE_AGENCY_PLATFORM_POST_BEGIN = 'syftacp/CREATE_AGENCY_PLATFORM_POST_BEGIN' as const
export const CREATE_AGENCY_PLATFORM_POST_FAILED = 'syftacp/CREATE_AGENCY_PLATFORM_POST_FAILED' as const
export const CREATE_AGENCY_PLATFORM_POST_SUCCEEDED = 'syftacp/CREATE_AGENCY_PLATFORM_POST_SUCCEEDED' as const
